import HubPage from './HubPage'

export default HubPage
